<template>
  <!-- PURCHASE FORM -->
  <div class="container checkout-page">
    <div class="checkout-wrapper row justify-content-center w-100">
      <div
        :class="
          !hasPaymentOption && !credit_applied
            ? 'col-lg-12'
            : 'col-lg-6 col-md-7'
        "
      >
        <div class="row text-left w-100 mb-2">
          <div class="col-12">
            <base-button
              class="checkout-back-link"
              type="link"
              @click="() => $router.back()"
              >&laquo; BACK</base-button
            >
          </div>
        </div>
        <div
          v-if="!stripe.cartItems.length"
          class="card bg-secondary border-0 mb-0 p-5 text-center"
        >
          There are no items in your cart.
        </div>
        <div v-else class="card bg-secondary border-0 mb-0">
          <div v-if="pageLoading" class="page-loading">
            <i class="fas fa-circle-notch fa-spin"></i>
          </div>
          <div v-if="!purchaseComplete" class="card-body px-lg-5 py-lg-4">
            <h2>Checkout</h2>
            <form role="form" @submit.prevent="handleSubmit">
              <div class="row">
                <div
                  v-if="!hasPaymentOption && !credit_applied"
                  class="col-md-6"
                >
                  <div class="form-row">
                    <div class="col">
                      <base-input
                        label="First Name"
                        class="mb-3"
                        type="text"
                        placeholder="First name"
                        v-model="form.fname"
                        spellcheck="false"
                        required
                        v-if="!hasPaymentOption"
                      ></base-input>
                    </div>
                    <div class="col">
                      <base-input
                        label="Last Name"
                        class="mb-3"
                        type="text"
                        placeholder="Last name"
                        v-model="form.lname"
                        spellcheck="false"
                        required
                        v-if="!hasPaymentOption"
                      ></base-input>
                    </div>
                  </div>
                  <base-input
                    label="Address line 1"
                    class="mb-3"
                    type="text"
                    placeholder="Street address"
                    v-model="form.address"
                    spellcheck="false"
                    required
                    v-if="!hasPaymentOption"
                  ></base-input>
                  <base-input
                    label="Address line 2"
                    class="mb-3"
                    type="text"
                    placeholder="Apt/suite number"
                    v-model="form.apartment"
                    spellcheck="false"
                    v-if="!hasPaymentOption"
                  ></base-input>
                  <div class="form-row">
                    <div class="col">
                      <base-input
                        label="City"
                        class="mb-3"
                        type="text"
                        placeholder="City"
                        v-model="form.city"
                        spellcheck="false"
                        required
                        v-if="!hasPaymentOption"
                      ></base-input>
                    </div>
                    <div class="col">
                      <base-input
                        label="State/Province/Region"
                        class="mb-3"
                        type="text"
                        placeholder="State/province"
                        v-model="form.state"
                        spellcheck="false"
                        required
                        v-if="!hasPaymentOption"
                      ></base-input>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="col">
                      <base-input
                        label="ZIP/Postal Code"
                        class="mb-3"
                        type="text"
                        placeholder="ZIP/postal code"
                        v-model="form.zip"
                        spellcheck="false"
                        required
                        v-if="!hasPaymentOption"
                      ></base-input>
                    </div>
                    <div class="col">
                      <base-input
                        label="Phone Number"
                        class="mb-3"
                        type="text"
                        placeholder="Phone number"
                        v-model="form.phone"
                        spellcheck="false"
                        required
                        v-if="!hasPaymentOption"
                      ></base-input>
                    </div>
                  </div>
                </div>
                <div
                  :class="
                    !hasPaymentOption && !credit_applied ? 'col-md-6' : 'col'
                  "
                >
                  <div v-if="!credit_applied" class="form-group mb-3">
                    <label class="form-control-label">Credit Card</label>
                    <div
                      v-if="!hasPaymentOption"
                      class="form-control"
                      ref="stripeCard"
                      id="stripe-card"
                    ></div>
                    <div v-else>
                      <div class="d-flex justify-content-between">
                        <i
                          v-if="user.card.brand === 'Visa'"
                          class="fab cc-icon fa-cc-visa"
                        ></i>
                        <i
                          v-else-if="user.card.brand === 'MasterCard'"
                          class="fab cc-icon fa-cc-mastercard"
                        ></i>
                        <i
                          v-else-if="user.card.brand === 'Discover'"
                          class="fab cc-icon fa-cc-discover"
                        ></i>
                        <i
                          v-else-if="user.card.brand === 'American Express'"
                          class="fab cc-icon fa-cc-amex"
                        ></i>
                        <strong v-else>{{ user.card.brand }}</strong>
                        <div>*******{{ user.card.last_four }}</div>
                        <div v-if="isCardExpired" class="text-danger">
                          <el-tooltip
                            effect="dark"
                            placement="top"
                            content="Card may be expired. Please update payment option."
                          >
                            <div class="warning-badge">
                              <i class="fas fa-exclamation-triangle mr-1"></i
                              >EXP: {{ user.card.exp_month }}/{{
                                user.card.exp_year
                              }}
                            </div>
                          </el-tooltip>
                        </div>
                        <div v-else>
                          EXP: {{ user.card.exp_month }}/{{
                            user.card.exp_year
                          }}
                        </div>
                      </div>
                      <div class="change-payment">
                        <a href="#" @click.stop.prevent="changePaymentOption"
                          >Change payment option</a
                        >
                      </div>
                    </div>

                    <div
                      v-if="!hasPaymentOption && wasInitiallyCharged && hasCard"
                      class="change-payment"
                    >
                      <a href="#" @click.stop.prevent="useExistingCard"
                        >Use existing card</a
                      >
                    </div>
                  </div>
                  <div
                    id="purchase-errors"
                    class="purchase-errors"
                    role="alert"
                  >
                    {{ formError || purchaseError }}
                  </div>
                  <div class="d-flex">
                    <div class="w-100">
                      <div class="purchase-total">
                        <div class="line-item">
                          <strong>Items ({{ cartLength }})</strong>
                        </div>
                      </div>
                      <div v-if="stripe.cartItems.length">
                        <div
                          v-for="item in stripe.cartItems"
                          v-bind:key="item.id"
                        >
                          <div
                            v-if="!item.is_design_service_only"
                            class="cart-row"
                          >
                            <div class="thumbnail">
                              <img :src="item.thumbnail" />
                            </div>
                            <div
                              v-if="unavailable.includes(item.artwork_id)"
                              class="details-col"
                            >
                              <badge type="danger">UNAVAILABLE</badge>
                            </div>
                            <div v-else class="details-col">
                              <div>
                                <strong>
                                  {{ itemId(item.type) }}
                                  <!-- #{{ item.artwork_id }} -->
                                </strong>
                              </div>
                              <div v-if="item.is_upgrade">License upgrade</div>
                              <div v-else>
                                {{
                                  item.license === "6mo"
                                    ? "6 month license"
                                    : "Forever license"
                                }}
                              </div>
                            </div>
                            <div class="price-col">
                              <span
                                v-if="!unavailable.includes(item.artwork_id)"
                                >${{ item.price }}</span
                              >
                            </div>
                            <div class="remove-col">
                              <button
                                @click.stop.prevent="handleDelete(item.id)"
                              >
                                <i
                                  title="Remove from cart"
                                  class="fa fa-trash-alt"
                                ></i>
                              </button>
                            </div>
                          </div>
                          <div v-if="item.design_service" class="service-row">
                            <div class="thumbnail">
                              <img :src="item.thumbnail" />
                              <i class="fas fa-pencil-ruler service-icon"></i>
                            </div>
                            <div class="details-col">
                              <div>
                                <strong> Design Service </strong>
                              </div>
                              <div>
                                {{
                                  item.design_service === "design_one"
                                    ? "One Revision"
                                    : "Two Revisions"
                                }}
                              </div>
                            </div>
                            <div class="price-col">
                              {{
                                item.design_service === "design_one"
                                  ? "$25.00"
                                  : "$40.00"
                              }}
                            </div>
                            <div class="remove-col">
                              <button
                                @click.stop.prevent="
                                  handleDelete(item.id, true)
                                "
                              >
                                <i
                                  title="Remove from cart"
                                  class="fa fa-trash-alt"
                                ></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="text-center p-5">
                        There are no items in your cart.
                      </div>
                      <div
                        v-if="unavailable.length === 0"
                        class="form-group purchase-total mt-2"
                      >
                        <div class="line-item">
                          <div class="purchase-description">Service Fee</div>
                          <div class="fee-description">
                            ${{ stripe.cartFees }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="unavailable.length === 0"
                        class="purchase-wrapper"
                      >
                        <small class="text-muted">TOTAL DUE</small>
                        <div class="purchase-price">
                          ${{ stripe.cartTotal }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="unavailable.length > 0"
                    class="purchase-errors mt-3"
                  >
                    Some items in your cart are no longer available. Please
                    remove them to continue.
                  </div>
                  <div class="text-center">
                    <base-button
                      type="primary"
                      :loading="loading"
                      nativeType="input"
                      block
                      class="mt-4"
                      :disabled="
                        purchaseComplete ||
                        updatingCart ||
                        unavailable.length > 0
                      "
                      size="lg"
                      >PAY
                      {{
                        unavailable.length > 0 ? "" : `$${stripe.cartTotal}`
                      }}</base-button
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div v-else class="purchase-complete card-body text-center">
            <h2>Purchase Complete</h2>
            <p>Thank you!</p>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <stripe-logo class="stripe-logo mt-4 mb-2"></stripe-logo>
        </div>
        <div class="d-flex cc-icons justify-content-center mb-4">
          <i class="fab fa-cc-visa mr-2"></i>
          <i class="fab fa-cc-mastercard mr-2"></i>
          <i class="fab fa-cc-discover mr-2"></i>
          <i class="fab fa-cc-amex"></i>
        </div>
      </div>
    </div>

    <!-- MODALS -->
    <update-payment-option />
    <typography-services-modal
      v-if="typographyServices.length"
      :options="typographyServices"
      @serviceSelected="addService"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
const stripeToken = process.env.VUE_APP_STRIPE_TOKEN;

let stripe = window.Stripe(stripeToken),
  elements = stripe.elements(),
  card = undefined;
import swal from "sweetalert2";
import { UpdatePaymentOption } from "../../components";
import StripeLogo from "../../components/StripeLogo.vue";
import TypographyServicesModal from "../../components/TypographyServicesModal.vue";
const apiBaseURL = process.env.VUE_APP_API_URL;

export default {
  name: "purchase",
  metaInfo: {
    title: "Art Grab : Purchase",
  },
  data() {
    return {
      form: {
        fname: "",
        lname: "",
        zip: "",
        address: "",
        apartment: "",
        city: "",
        state: "",
        phone: "",
        coupon_sku: "",
      },
      loading: false,
      formError: "",
      plan_cost: "",
      // calculated_price: "0.00",
      modals: {
        paymentOption: false,
        typographyService: false,
      },
      proFileId: null,
      purchaseComplete: false,
      animationId: null,
      artworkId: null,
      thumbnail: "/img/brand/ag-logo.png",
      credit_applied: false,
      pageLoading: false,
      has_new_card: false,
      typographyValue: "",
      typographyName: "",
      typographyServices: [],
      updatingCart: false,
      cardMounted: false,
    };
  },
  components: {
    UpdatePaymentOption,
    TypographyServicesModal,
    StripeLogo,
  },
  methods: {
    itemId(type) {
      if (type === "pro") return "PRO File";
      return type.charAt(0).toUpperCase() + type.slice(1);
    },
    handleDelete(id, removeDesignService = false) {
      swal
        .fire({
          title: "ARE YOU SURE?",
          text: "Are you sure you want to remove this item?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#000",
          cancelButtonColor: "#f5365c",
          confirmButtonText: "YES, REMOVE IT",
        })
        .then((result) => {
          if (result.value) {
            this.updatingCart = true;
            this.axios
              .post(`${apiBaseURL}/api/artv1.1/user/removefromcart`, {
                id,
                removeDesignService,
              })
              .then((result) => {
                if (result.data.data.message === "Success") {
                  this.$store.dispatch("getCart");
                } else if (result.data.data.api_action_error) {
                  this.showErrorAlert(
                    `There was a problem removing this item from your cart. Please try again, or contact Art Grab support for help.`
                  );
                }
              })
              .catch((error) => {
                /*eslint no-console: ["error", { allow: ["warn", "error"] }] */
                console.error(error);
              })
              .finally(() => {
                this.updatingCart = false;
              });
          }
        });
    },
    purchase(stripeResult) {
      const baseURI = apiBaseURL;
      const endpoint = "/api/artv1.1/user/purchase";
      let data = {};

      if (!stripeResult) {
        data = {
          referral: this.referral,
          has_new_card: this.has_new_card,
          build_hash: this.buildHash,
        };
      } else {
        data = {
          email: this.user.email,
          fname: this.form.fname,
          lname: this.form.lname,
          address: this.form.address,
          apartment: this.form.apartment,
          city: this.form.city,
          state: this.form.state,
          zip: this.form.zip,
          phone: this.form.phone,
          stripetoken: stripeResult ? stripeResult.token.id : null,
          ip_address: stripeResult ? stripeResult.token.client_ip : null,
          referral: this.referral,
          has_new_card: this.has_new_card,
          build_hash: this.buildHash,
        };
      }

      this.axios
        .request({
          baseURL: baseURI,
          url: endpoint,
          method: "post",
          data,
        })
        .then((result) => {
          if (result.data.error_code == 0 && result.data.message == "Success") {
            if (result.data.data.message == "Success") {
              this.$store.commit("user", {
                email: this.user.email,
                fname: this.form.fname,
                lname: this.form.lname,
              });
              this.showSuccessAlert();
            } else if (result.data.data.error_code.includes("606")) {
              this.loading = false;
              this.showErrorAlert(
                `We're sorry, there was an error processing the payment. Error: ${result.data.data.error}`
              );
            } else if (result.data.data.error_code === "607") {
              this.loading = false;
              this.showErrorAlert(
                `We're sorry, some items in your cart are no longer available.`
              );
              this.$store.commit(
                "setCartUnavailable",
                result.data.data.unavailable
              );
            } else {
              this.loading = false;
              this.showErrorAlert(
                "Card was declined. Please check all the information and try again. If your card details were saved, please click the change payment option link to update the card details."
              );
            }
          } else {
            this.loading = false;

            this.showErrorAlert(
              "There was an error processing this payment. Please contact us for support."
            );
          }
        })
        .catch((error) => {
          this.loading = false;

          this.showErrorAlert(
            `There was an error processing this payment. Please contact us for support. ${error}`
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSubmit: function () {
      let self = this;
      self.loading = true;

      if (this.credit_applied) {
        self.purchase();
      } else {
        if (!self.hasPaymentOption || this.has_new_card) {
          stripe
            .createToken(card, {
              name: `${self.form.fname} ${self.form.lname}`,
              address_line1: self.form.address,
              address_line2: self.form.apartment,
              address_city: self.form.city,
              address_state: self.form.state,
              address_zip: self.form.zip,
            })
            .then(function (stripeResult) {
              if (stripeResult.error) {
                self.hasCardErrors = true;
                self.loading = false;

                self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
                self.showErrorAlert(
                  "Card has an error. Please check card before resubmitting."
                );
                return;
              }
              self.purchase(stripeResult);
            });
        } else {
          self.purchase();
        }
      }
    },
    showErrorAlert(message) {
      swal.fire({
        type: "error",
        title: "Oh no!",
        text: message,
        confirmButtonColor: "#000",
      });
    },
    showSuccessAlert() {
      let successText = "Your purchase is complete. Click OK to continue.";

      swal.fire({
        type: "success",
        title: "Success!",
        text: successText,
        confirmButtonColor: "#000",
        onClose: this.goToDashboard,
      });
    },
    goToDashboard() {
      this.$store.dispatch("getPaymentOption");
      this.$router.push({ path: "/myimages" });
    },
    changePaymentOption() {
      this.has_new_card = true;
      this.$store.commit("hasPaymentOption", false);
      this.initializeStripeCard();
    },
    useExistingCard() {
      this.has_new_card = false;
      this.$store.commit("hasPaymentOption", true);
    },
    clearForm() {
      this.$store.commit("purchaseError", "");
      this.form.formError = "";
      this.form.fname = "";
      this.form.lname = "";
      this.form.zip = "";
      this.form.phone = "";
      this.loading = false;
      // this.plan_cost = "";
    },
    initializeStripeCard() {
      const style = {
        base: {
          "::placeholder": {
            color: "#8898aa",
          },
        },
      };

      this.has_new_card = true;

      if (typeof card !== "object" || card === null) {
        card = elements.create("card", { hidePostalCode: true, style: style });
      }
      this.$nextTick(() => {
        if (document.getElementById("stripe-card")) {
          try {
            card.mount("#stripe-card");
            this.cardMounted = true;
          } catch (e) {
            console.error(e);
            this.$nextTick(() => {
              card.mount("#stripe-card");
            });
            this.cardMounted = false;
          }
        } else {
          this.cardMounted = false;
        }
      });

      // if (!this.$refs.stripeCard) {
      //   this.$nextTick(() => {
      //     card.mount(this.$refs.stripeCard);
      //   });
      // } else {
      //   card.mount(this.$refs.stripeCard);
      // }

      // Handle real-time validation errors from the card element.
      card.addEventListener("change", function (event) {
        var displayError = document.getElementById("purchase-errors");
        if (event.error) {
          displayError.textContent = event.error.message;
        } else {
          displayError.textContent = "";
        }
      });
    },
    // getThumbnail() {
    //   const endpoint =
    //     this.plan === "image" || this.plan === "pro_file"
    //       ? `${apiBaseURL}/api/artv1.1/photo/info?id=${this.artworkId}&purchase=true`
    //       : `${apiBaseURL}/api/artv1.1/animation/info?id=${this.animationId}&purchase=true`;
    //   this.axios
    //     .get(endpoint)
    //     .then((result) => {
    //       if (result.data.error_code == 0 && result.data.message == "Success") {
    //         if (result.data.data.message == "Success") {
    //           this.thumbnail =
    //             this.plan === "animation"
    //               ? `${process.env.VUE_APP_ANIMATION_CDN_URL}${result.data.data.animation.poster_url_path}`
    //               : `${process.env.VUE_APP_CDN_BASE_URL}${result.data.data.photo.watermark_url_path}`;
    //           if (this.plan === "animation") {
    //             this.calculated_price =
    //               result.data.data.animation.animation_price;
    //           } else if (this.plan === "pro_file") {
    //             this.calculated_price = result.data.data.photo.pro_file_price;
    //           } else {
    //             this.credit_applied = result.data.data.credit_applied;
    //             this.calculated_price = result.data.data.photo.photo_price;
    //           }
    //         }
    //       }
    //     })
    //     .finally(() => {
    //       this.pageLoading = false;
    //     });
    // },
  },
  computed: {
    ...mapState([
      "purchaseError",
      "isLoggedIn",
      "plan",
      "user",
      "hasPaymentOption",
      "referral",
      "wasInitiallyCharged",
      "buildHash",
      "stripe",
    ]),
    unavailable() {
      return this.stripe.cartUnavailable;
    },
    cartLength() {
      const count = this.stripe.cartItems.length;
      const designServices = this.stripe.cartItems.filter(
        (i) => !!i.design_service
      ).length;
      const designOnlyCount = this.stripe.cartItems.filter(
        (i) => !!i.is_design_service_only
      ).length;
      return count + designServices - designOnlyCount;
    },
    hasCard() {
      return this.user.card && this.user.card.last_four;
    },
    plan_title() {
      switch (this.plan) {
        case "pro_file":
          return "PRO FILE";
        case "animation":
          return "ANIMATION";
        default:
          return "IMAGE";
      }
    },
    isCardExpired() {
      const cardDate = new Date(
        `${this.user.card.exp_month}/28/${this.user.card.exp_year}`
      );
      const today = new Date();
      return cardDate < today;
    },
    // totalPrice() {
    //   let total = this.calculated_price;

    //   if (parseFloat(total) > 0) {
    //     total = parseFloat(this.calculated_price) + 5.99;
    //     if (this.typographyValue) {
    //       total = total + parseFloat(this.typographyValue);
    //     }
    //     return total.toFixed(2);
    //   }
    //   return total;
    // },
  },
  mounted: function () {
    // this.pageLoading = true;
    this.$store.commit("setLayout", "checkout-layout");
    this.clearForm();

    this.$store.dispatch("getCart");

    // this.getThumbnail();

    if (!this.hasPaymentOption && this.stripe.cartItems.length) {
      this.initializeStripeCard();
    }
  },
  watch: {
    "stripe.cartItems": function (value) {
      if (value.length) {
        if (!this.hasPaymentOption && !this.cardMounted) {
          this.initializeStripeCard();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.checkout-page {
  width: 100%;
  padding-top: 60px;
  padding-bottom: 30px;

  .stripe-logo {
    width: 120px;
    svg {
      fill: black;
    }
  }

  .checkout-back-link {
    &:active,
    &:focus {
      box-shadow: none !important;
    }
  }

  .checkout-wrapper {
    margin: 0 auto;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    height: calc(100% - 30px);
  }

  .cart-row,
  .service-row {
    display: flex;
    margin-bottom: 8px;
    align-items: center;

    .details-col {
      display: flex;
      flex-direction: column;
      padding-left: 10px;
      font-size: 0.75rem;
      line-height: 1.2;
    }

    .price-col {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 0.875rem;
      // font-weight: bold;
    }

    .unavailable {
      text-decoration: line-through;
    }

    .remove-col {
      display: flex;
      align-items: center;

      button {
        background: none;
        border: none;
        padding: 8px;
        color: rgb(255, 81, 81);
        font-size: 14px;

        &:hover,
        &:active,
        &:focus {
          outline: none;
        }
      }
    }

    .service-icon {
      position: absolute;
      top: 11px;
      left: 10px;
      color: white;
      font-size: 10px;
    }

    .thumbnail {
      overflow: hidden;
      border-radius: 4px;
      width: 30px;
      height: 30px;
      position: relative;

      img {
        border-radius: 4px;
        width: 30px;
        height: 30px;
        object-fit: cover;
        object-position: center;
      }
    }
  }
}
.cc-icon {
  font-size: 1.5rem;
  color: #666;
}

.discount-message {
  margin-top: 12px;
  color: #2dce89;
  font-weight: 600;
  font-size: 0.875rem;
}

.typography-section {
  background: #f4f4f4;
  border-radius: 4px;
  padding: 8px;

  small {
    font-weight: 600;
  }
}

.checkout-title {
  margin-top: 12px;
  font-size: 1.75rem;
  font-weight: 700;
  line-height: 1;
}

.page-loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  padding: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: white;

  i {
    font-size: 8rem;
    color: #eee;
  }
}

.plan-toggle {
  padding: 0.5rem;
  background-color: #f7f7f7;
  border-radius: 3px;
  display: flex;
  justify-content: space-around;
  margin-bottom: 2rem;
}

.checkout-thumb {
  width: 100px;
  border-radius: 3px;
  margin: 0 auto;
}
.purchase-complete {
  padding-top: 200px;
  padding-bottom: 200px;
}

.change-payment {
  text-align: right;
  margin-top: 0.25rem;
}

.purchase-errors {
  font-size: 0.875rem;
  color: red;
  text-align: center;
}

.credit-applied {
  padding: 16px;
  font-size: 0.875rem;
  font-weight: bold;
  background: #f7f7f7;
  margin-top: 12px;
  border-radius: 3px;

  small {
    display: block;
    line-height: 1.5;
    margin-top: 10px;
  }
}

.purchase-total {
  display: flex;
  margin: 0.5rem 0;
  flex-direction: column;

  .line-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
  }

  .purchase-description {
    font-size: 1rem;
    line-height: 1;
    font-weight: 700;
    margin-top: 16px;
  }

  .fee-description {
    font-size: 1rem;
    line-height: 1;
    margin-top: 16px;
  }
}

.purchase-wrapper {
  line-height: 1;
  text-align: right;
  margin-top: 12px;

  .text-muted {
    font-weight: 700;
  }

  .purchase-price {
    font-size: 1.75rem;
    font-weight: 700;
  }
}

.cc-icons {
  font-size: 1.35rem;
}

.coupon-code {
  text-align: right;
  margin-bottom: 0;

  .coupon-input {
    margin-top: 1rem;
  }

  .coupon-message {
    font-weight: 600;
    background-color: #bdbdbd;
    color: white;
    border-radius: 3px;
    text-align: center;
    padding: 0.2rem;
  }
}

@media (max-width: 575.98px) {
  .checkout-page {
    padding-top: 40px;
  }

  .credit-button {
    &:hover {
      transform: translateY(0);
    }
  }
}
</style>
